import {
  getSharedProfileAvatar as getProfileAvatar,
  getSharedProfileBio,
  getSharedProfileDisplayName,
} from '@litopia/shared/utils/profile-display';
import type { SharedProfileData } from '@litopia/shared';

export { getSharedProfileBio, getSharedProfileDisplayName };

export function getSharedProfileAvatar(profile: SharedProfileData | null | undefined) {
  const avatarUrl = getProfileAvatar(profile);
  if (!avatarUrl) return null;

  // Some older shared-profile rows still point at the retired OPP staging host.
  // Keep Litopia's shared data intact while making those legacy URLs resolve in OPP.
  return avatarUrl.replace('://staging.openpenpal.com/', '://openpenpal.com/');
}
